import { CHCHomepageBanner } from './shop-plans-banner.component.js';
export { CHCHomepageBanner };

customElements.define('chcapp-shop-plans-banner', CHCHomepageBanner);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-shop-plans-banner': CHCHomepageBanner;
  }
}
